function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "m0 0h.5 2.8432v1h-2.3432v7h6.75v-2.23372h1v2.73372.5h-.5-7.75-.5v-.5-8zm8.76752.510548v3.891592h-1v-2.63008l-4.17491 4.1749-.7071-.7071 4.22931-4.22931h-2.73889v-1.000003l3.89159.0000005.5.0000001z",
  fill: "#2b557c",
  fillRule: "evenodd"
});

var SvgOpen = function SvgOpen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    fill: "none",
    height: 9,
    viewBox: "0 0 9 9",
    width: 9,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOpen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/open.b6ac882f.svg";
export { ForwardRef as ReactComponent };